import { reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer, { DataActions } from "@toolkit/Extensions/Store/Data/DataReducer";
import mergeReducer from "@toolkit/Framework/Common/Utilities/redux/mergeReducer";

reducers.data = mergeReducer(reducers.data, dataReducer);

// This type must be added to the "ReduxActions" interface in the `src/_typings/store.d.ts` file of the blueprint
export type ExtendedActions = DataActions;
